import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import { httpService } from "../httpService";
import { useParams } from "react-router-dom";
import { LinearProgress, Typography } from "@mui/material";

function JambStaffPrintout() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [jambData, setJambData] = useState(null);
  const getData = async () => {
    setLoading(true);
    const { data, error } = await httpService(`viewjambstaff/${id}`);

    if (data) {
      setJambData(data);
    }

    if (error) {
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div>
      <div className="container mt-5">
        <div>
          <div className="text-center mb-4">
            <img src={logo} alt="logo" width="120" height="100" />
          </div>
          {loading && (
            <div className="col-lg-4">
              <LinearProgress />
            </div>
          )}
          {jambData && (
            <div className="mb-3">
              <div className="mb-5">
                <h3 className="text-700 text-muted">JAMB STAFF REGISTRATION</h3>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="mb-4">
                    <Typography variant="caption">Name</Typography>
                    <Typography variant="h6" textTransform={"capitalize"}>
                      {jambData.name}
                    </Typography>
                  </div>
                  <div className="mb-4">
                    <Typography variant="caption">ID Card</Typography>
                    <Typography variant="h6" textTransform={"uppercase"}>
                      {jambData.idCard}
                    </Typography>
                  </div>
                  <div className="mb-4">
                    <Typography variant="caption">Department</Typography>
                    <Typography variant="h6" textTransform={"uppercase"}>
                      {jambData.department}
                    </Typography>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mb-4">
                    <Typography variant="caption">Level</Typography>
                    <Typography variant="h6" textTransform={"uppercase"}>
                      {jambData.level}
                    </Typography>
                  </div>
                  <div className="mb-4">
                    <Typography variant="caption">Phone Number</Typography>
                    <Typography variant="h6" textTransform={"uppercase"}>
                      {jambData.phoneNumber}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default JambStaffPrintout;
